module.exports = __webpack_public_path__ + "img/5a612c2.png";